import { render, staticRenderFns } from "./LimitlessPageSidebar.vue?vue&type=template&id=583c58db&"
import script from "./LimitlessPageSidebar.vue?vue&type=script&lang=js&"
export * from "./LimitlessPageSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports